module.exports = __webpack_public_path__ + "static/shape-logo-footer-d43fff9513d550c592b90805b509952f.png";